export default {"src":"/_next/static/image/public/images/ic_no_order.79be9335a9554d6d943c707290a0c21c.svg","height":131,"width":132};